export class ProcessLossPercentageUtil {
  static convertUserPercentageToInternal(userPercentage: number): number {
    if (!userPercentage || userPercentage <= 0) return 0;
    return 1 - 1 / (1 + userPercentage / 100);
  }

  static convertInternalToUserPercentage(internalValue: number): number {
    if (!internalValue || internalValue <= 0) return 0;
    return (1 / (1 - internalValue) - 1) * 100;
  }

  static convertUserPercentageToDBValue(userPercentage: number): number {
    if (!userPercentage || userPercentage <= 0) return 0;
    const internalValue = this.convertUserPercentageToInternal(userPercentage);
    return internalValue * 100;
  }

  static convertDBValueToUserPercentage(dbValue: number): number {
    if (!dbValue || dbValue <= 0) return 0;
    const internalValue = dbValue / 100;
    return this.convertInternalToUserPercentage(internalValue);
  }

  static getInternalPercentageDisplay(userPercentage: number): number {
    if (!userPercentage || userPercentage <= 0) return 0;
    return this.convertUserPercentageToDBValue(userPercentage);
  }
}
